import type { DealsFilterValue } from "@/models/applications";

export const filterHasValue = (
  value:
    | DealsFilterValue
    | string
    | number
    | string[]
    | number[]
    | null
    | undefined
) =>
  Array.isArray(value) ? !!value.length : !!value || Number.isInteger(value);
